
import { Component, Prop, Vue } from 'vue-property-decorator';
import { get, put } from '@/services/http';
import { StoreModel } from '@/models/store';
import { EventBus } from '@/main';
import { listAutoKeys } from '@/services/po-email-template-substitution';

@Component({ name: 'PoEmailTemplate' })
export default class PoEmailTemplate extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;

  private template: { subject: string; body: string } = { subject: '', body: '' };
  private loading = true;
  private saving = false;
  private hasChanges = false;
  private autoKeys: string[] = listAutoKeys();
  // Vue's template compiler rejects `{{…}}` inside attributes and needs escaping in
  // text interpolations — so we build placeholder strings dynamically.
  private subjectPlaceholder = 'e.g. PO {{po.number}} — please confirm';
  private bodyPlaceholder = 'Hi {{supplier.contact_name}},...';

  private formatVariable(key: string): string {
    return `{{${key}}}`;
  }

  public async created() {
    await this.fetchTemplate();
  }

  private async fetchTemplate(): Promise<void> {
    this.loading = true;
    try {
      const response: any = await get('/purchase_orders/config/email-template');
      const data = response?.data || { subject: '', body: '' };
      this.template = { subject: data.subject || '', body: data.body || '' };
      this.hasChanges = false;
    } catch (error) {
      console.error('Failed to fetch PO email template:', error);
      EventBus.$emit('show-snackbar', 'Failed to load PO email template', 'error');
    } finally {
      this.loading = false;
    }
  }

  private async save(): Promise<void> {
    this.saving = true;
    try {
      await put('/purchase_orders/config/email-template', {
        subject: this.template.subject,
        body: this.template.body,
      });
      this.hasChanges = false;
      EventBus.$emit('show-snackbar', 'PO email template saved', 'success');
    } catch (error) {
      console.error('Failed to save PO email template:', error);
      EventBus.$emit('show-snackbar', 'Failed to save PO email template', 'error');
    } finally {
      this.saving = false;
    }
  }

  private async copyVariable(key: string): Promise<void> {
    const text = `{{${key}}}`;
    try {
      await navigator.clipboard.writeText(text);
      EventBus.$emit('show-snackbar', `Copied ${text}`, 'info');
    } catch (error) {
      console.warn('Clipboard copy failed:', error);
      EventBus.$emit('show-snackbar', 'Failed to copy to clipboard', 'error');
    }
  }
}
